import "./PrimaryReturnQtyCell.css";

interface styles {
  boxStyle?: React.CSSProperties;
}

interface PrimaryReturnQtyCellProps {
  pcQty?: number;
  csQty?: number;
  otherQty?: number;
  otherUnitName?: string;
  customStyles?: styles;
}

const PrimaryReturnQtyCell: React.FC<PrimaryReturnQtyCellProps> = ({
  pcQty = 0,
  csQty = 0,
  otherQty = 0,
  otherUnitName,
  customStyles,
}) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") || "{}");
  const { caseUnitLabelPrimaryReturn, otherUnitLabelPrimaryReturn, packUnitLabelPrimaryReturn } = ConfigDictionary;
  const othUnit = otherUnitName ?? otherUnitLabelPrimaryReturn

    return (<div className="PrimaryQtyCell_root" style={customStyles?.boxStyle}>
        
        {caseUnitLabelPrimaryReturn && (
        <div className="MultiQtyCell_child_containerV2">
          <div className="MultiQtyCell_qty">{csQty}</div>
          <div className="MultiQtyCell_label">{caseUnitLabelPrimaryReturn}</div>
        </div>
      )}
        {othUnit && (
          <div className="MultiQtyCell_child_containerV2">
            <div className="MultiQtyCell_qty">{otherQty}</div>
            <div className="MultiQtyCell_label">{othUnit}</div>
          </div>
        )}
        {packUnitLabelPrimaryReturn&& (
        <div className="MultiQtyCell_child_containerV2">
          <div className="MultiQtyCell_qty">{pcQty}</div>
          <div className="MultiQtyCell_label">{packUnitLabelPrimaryReturn}</div>
        </div>
        )}
      </div>
    )
  }

export default PrimaryReturnQtyCell;
